export default __webpack_public_path__ + "static/media/token_sGWS.489e3797.svg";